const en = {
  nav: {
    home: "Home",
    about: "About",
    services: "Services",
    industries: "Industries",
    whyUs: "Why Us",
    contact: "Contact",
    portal: "Client Portal",
  },
  mobileNav: {
    home: "Home",
    projects: "Portfolio",
    applications: "Applications",
    profile: "Profile",
  },
  about: {
    badge: "About Us",
    title: "Who is",
    titleHighlight: "Cloud Mature?",
    description: "Cloud Mature is an information technology company based in Conakry, dedicated to helping organizations transform to the Cloud, whether public, private, or hybrid, with a secure, high-performance approach that meets the highest standards. Certified Microsoft, AWS and Google Cloud experts, we design robust multi-cloud architectures and support organizations through their digital transformation with rigor, proximity and commitment.",
    missions: [
      { title: "Multi-Cloud Architectures", desc: "Design infrastructures on Azure, AWS and GCP - from public to private cloud - with resilient, scalable architectures optimized for your business context." },
      { title: "Operational Excellence", desc: "CI/CD automation, Infrastructure-as-Code (Terraform, Bicep, CloudFormation), advanced monitoring and FinOps governance to maximize your ROI." },
      { title: "Artificial Intelligence", desc: "Deploy AI solutions on Azure OpenAI, AWS Bedrock and Google Vertex AI. Microsoft Copilot integration and intelligent automation of your business processes." },
      { title: "Tailored Partnership", desc: "Hands-on partnership with certified local teams that are available and committed. Customized solutions adapted to every industry." },
      { title: "Security, Sovereignty & Compliance", desc: "Sovereign-cloud oriented architectures and data residency, Zero Trust policies, Microsoft Defender, AWS Security Hub, Google Chronicle. ISO 27001, SOC 2 and GDPR compliance to protect your digital assets." },
      { title: "Skills Development", desc: "Training and coaching on Microsoft, AWS and GCP ecosystems to ensure technological autonomy and long-term success of your transformation." },
    ],
  },
  hero: {
    words: ["Innovate.", "Optimize.", "Automate."],
    badge: { consulting: "Consulting", cloud: "Cloud", devops: "DevOps", ai: "AI" },
    description: "Cloud Mature helps organizations transform to the Cloud, whether public, private, or hybrid, with a secure, high-performance approach that meets the highest standards.",
    cta: "Request a consultation",
    become: "Become a client",
    multiCloud: "Multi-Cloud",
    multiCloudDesc: "AWS, Azure, GCP",
    security: "Security",
    securityDesc: "ISO 27001, SOC 2",
    finops: "FinOps",
    finopsDesc: "Cost optimization",
  },
  services: {
    badge: "Our Services",
    title: "What we",
    titleHighlight: "actually deliver",
    subtitle: "Licenses, hardware, tailored solutions - we provide all the products and services needed for your Cloud, hybrid or private infrastructure.",
    imageCaption: "Expertise at the service of your transformation",
    items: [
      { title: "Microsoft 365 & Azure Ecosystem", desc: "Deployment and management of Microsoft 365, Azure, Entra ID, Intune, Defender and Power Platform. CSP/EA licensing, Exchange/SharePoint migrations and user adoption." },
      { title: "Cloud Licenses & Subscriptions", desc: "Provisioning of Microsoft, AWS and Google Workspace licenses. Renewal management, cost optimization and multi-vendor consolidation." },
      { title: "Hybrid & Private Infrastructure", desc: "Delivery of server, storage and network equipment. Azure Stack HCI, AWS Outposts, VMware and hyperconverged solution integration for your datacenters." },
      { title: "Cloud Architecture, Engineering & Migration", desc: "Multi-cloud design (Azure, AWS, GCP) with Infrastructure-as-Code (Terraform, Bicep), Kubernetes and microservices. Lift & Shift or refactoring migrations (Azure Migrate, AWS Migration Hub) and zero-downtime workload modernization." },
      { title: "Modern Business App Development", desc: "Design and development of tailored business applications: web, mobile and SaaS. Cloud-native, API-first architectures with integrations to your systems (ERP, CRM, SharePoint) and embedded generative AI." },
      { title: "Security & Compliance", desc: "Microsoft Defender & Sentinel, AWS Security Hub, Google Chronicle. Zero Trust policies, identity management and ISO 27001, SOC 2, GDPR compliance." },
      { title: "Managed Services & Support", desc: "Proactive 24/7 multi-cloud monitoring, L1 to L3 support, incident management, performance monitoring and contractual SLA tracking." },
      { title: "AI & Intelligent Automation", desc: "Microsoft Copilot, Azure OpenAI, AWS Bedrock and Google Vertex AI. Process automation and AI integration into your business tools." },
      { title: "Sovereign Cloud & Data Residency", desc: "A strong priority of Cloud Mature. We design sovereign-cloud oriented architectures: compliant region and availability-zone selection, customer-managed encryption (BYOK/HYOK), network isolation, full auditability and local hosting when regulation requires it. Tailored to public sector, financial, healthcare and strategic organizations." },
    ],
  },
  industries: {
    badge: "Industries",
    title: "Who are",
    titleHighlight: "our services for?",
    subtitle: "We design Cloud architectures and AI solutions tailored to the specific requirements of each industry, on Microsoft Azure, AWS and Google Cloud.",
    items: [
      { title: "Banking & Finance", desc: "PCI-DSS compliant Azure and AWS infrastructures, high-availability architectures, AI for fraud detection and predictive analytics." },
      { title: "Insurance", desc: "Legacy system migration to the Cloud, underwriting process automation and intelligent claims management with AI." },
      { title: "Mining Companies", desc: "Edge computing and IoT on Azure IoT Hub and AWS IoT Core, hybrid connectivity for remote sites, AI-driven predictive maintenance." },
      { title: "Governments & Public Sector", desc: "Sovereign clouds, architectures compliant with data residency requirements, digital transformation of public services." },
      { title: "Startups & Scale-ups", desc: "Serverless architectures on Azure Functions, AWS Lambda and GCP Cloud Run. Scalable infrastructure and CI/CD to accelerate time-to-market." },
      { title: "Telecoms & IT", desc: "Network infrastructure modernization, Kubernetes containerization (AKS, EKS, GKE), DevOps and advanced observability." },
    ],
    learnMore: "Learn more →",
  },
  microsoft: {
    badge: "Microsoft Partner",
    title: "Microsoft 365 + Copilot",
    subtitle: "Official licenses, secure migration, adoption and Microsoft AI integration into your business processes.",
    valueProps: [
      { title: "Official Licenses", desc: "Get Microsoft 365, Azure and Copilot licenses through an authorized CSP partner, with preferential pricing and local support." },
      { title: "Smooth Migration", desc: "We guide your teams in migrating your emails, files and applications to the Microsoft cloud." },
      { title: "Artificial Intelligence", desc: "Deploy Microsoft Copilot in your daily tools to boost productivity and automate repetitive tasks." },
    ],
    whyTitle: "Why choose Microsoft 365 with Cloud Mature?",
    whyText: "As a Microsoft partner, Cloud Mature supports you from auditing your current environment to training your users. We ensure the compliance, security and performance of your Microsoft ecosystem, while helping you get the most out of generative AI with Copilot.",
    offerTitle: "Our offer includes",
    offerItems: [
      "Consulting and audit of your Microsoft environment",
      "Provisioning of Microsoft 365, Azure and Copilot licenses",
      "Exchange, SharePoint, OneDrive and Teams migration",
      "Copilot deployment and configuration",
      "User training and adoption",
      "Managed services and support",
    ],
    ctaTitle: "Ready to transform your work with Microsoft 365?",
    ctaText: "Request a free quote for your Microsoft 365 and Copilot licenses. Our team will respond within 24 hours.",
    ctaButton: "Request a quote",
    infographicHint: "Click to enlarge the infographic",
  },
  whyUs: {
    badge: "Advantages",
    title: "Why choose",
    titleHighlight: "Cloud Mature?",
    items: [
      { title: "Microsoft & Multi-Cloud Expertise", desc: "Certified Microsoft partner with advanced skills on AWS and Google Cloud for hybrid and multi-cloud architectures." },
      { title: "Tailored Solutions", desc: "From architecture to delivery - licenses, hardware, application development and AI integration adapted to your business." },
      { title: "Measurable Results", desc: "Contractual KPIs, guaranteed SLAs, FinOps reporting and real-time dashboards for transparent tracking." },
      { title: "Security & Sovereignty", desc: "Zero Trust, SIEM/SOAR (Sentinel, Security Hub), sovereign-cloud oriented architectures and data residency, ISO 27001, SOC 2 and GDPR compliance across all platforms." },
      { title: "Certified Local Team", desc: "Conakry-based engineers certified in Azure, AWS and GCP, available and responsive for hands-on support." },
      { title: "Bilingual FR/EN", desc: "Documentation, support and training in French and English for regional and international coverage." },
    ],
  },
  contact: {
    badge: "Contact",
    title: "Let's talk about your",
    titleHighlight: "Cloud project",
    subtitle: "Contact us for a free consultation and discover how Cloud Mature can transform your infrastructure.",
    namePlaceholder: "Your name *",
    emailPlaceholder: "Email *",
    companyPlaceholder: "Company *",
    messagePlaceholder: "Your message *",
    send: "Send",
    sending: "Sending...",
    successTitle: "Message sent!",
    successDesc: "We'll get back to you as soon as possible.",
    errorTitle: "Error",
    errorDesc: "Please try again.",
    validationName: "Name is required.",
    validationEmail: "Email is required.",
    validationEmailInvalid: "Please enter a valid email.",
    validationCompany: "Company is required.",
    validationMessage: "Message is required.",
  },
  footer: {
    copyright: "© {year} Cloud Mature. All rights reserved. Innovate · Optimize · Automate",
    privacy: "Privacy Policy",
    terms: "Terms of Use",
    partners: "Our partners",
  },
  privacy: {
    title: "Privacy Policy",
    lastUpdated: "Last updated: April 2026",
    sections: [
      { title: "1. Introduction", content: "Cloud Mature ('we', 'our') is committed to protecting the privacy of users of its services and website. This policy describes the data we collect, how we use it and the measures we take to protect it." },
      { title: "2. Data Collected", content: "We collect information you provide directly: name, email address, phone number, company name, and any information submitted through our contact forms or client portal.\n\nWe also automatically collect technical data: IP address, browser type, pages visited and visit duration." },
      { title: "3. Use of Data", content: "Your data is used to:\n• Provide and improve our Cloud, DevOps and AI services\n• Manage your client portal account\n• Communicate with you regarding your projects and support requests\n• Ensure the security of our systems\n• Comply with our legal obligations" },
      { title: "4. Data Sharing", content: "We never sell your personal data. We may share it with:\n• Our technical subcontractors (Cloud hosting, email delivery) strictly within the scope of service provision\n• Competent authorities when legally required\n\nAll our partners are bound by confidentiality obligations." },
      { title: "5. Security", content: "We implement industry-standard security measures: encryption of data in transit and at rest, multi-factor authentication, Zero Trust policies, role-based access control (RBAC) and continuous monitoring of our infrastructure." },
      { title: "6. Data Retention", content: "Your data is retained as long as necessary to provide our services or comply with our legal obligations. Account data is deleted within 30 days of account closure." },
      { title: "7. Your Rights", content: "In accordance with applicable regulations, you have the following rights:\n• Access to your personal data\n• Rectification of inaccurate information\n• Deletion of your data\n• Objection to processing\n• Data portability\n\nTo exercise these rights, contact us at info@cloudmature.com." },
      { title: "8. Cookies", content: "Our site uses essential cookies for functionality (session, language preferences). No advertising or third-party tracking cookies are used." },
      { title: "9. Contact", content: "For any questions about this policy, contact us:\nCloud Mature - Conakry, Guinea\nEmail: info@cloudmature.com" },
    ],
  },
  terms: {
    title: "Terms of Use",
    lastUpdated: "Last updated: April 2026",
    sections: [
      { title: "1. Purpose", content: "These terms of use ('Terms') govern access to and use of the Cloud Mature website and client portal. Cloud Mature is an information technology company specializing in Cloud, DevOps and Artificial Intelligence." },
      { title: "2. Acceptance", content: "By accessing our services or creating an account on the client portal, you unconditionally accept these Terms. If you do not accept these conditions, please do not use our services." },
      { title: "3. Description of Services", content: "Cloud Mature provides multi-cloud consulting, architecture and engineering services (Microsoft Azure, AWS, Google Cloud), including:\n• Cloud licenses and subscriptions (Microsoft 365, Azure, AWS, Google Workspace)\n• Equipment for hybrid and private infrastructures\n• Security and compliance solutions\n• Managed services and technical support\n• Artificial Intelligence integration" },
      { title: "4. User Account", content: "Access to the client portal requires account creation. You are responsible for the confidentiality of your credentials and all activity under your account. Multi-factor authentication (MFA) is mandatory for all users." },
      { title: "5. User Obligations", content: "You agree to:\n• Provide accurate and up-to-date information\n• Complete your profile within 30 days of account creation\n• Not attempt to access unauthorized resources\n• Comply with applicable laws and regulations\n• Not use our services for unlawful purposes" },
      { title: "6. Intellectual Property", content: "All content on the site and portal (text, images, logos, source code) is the exclusive property of Cloud Mature or its partners. Any unauthorized reproduction, distribution or use is strictly prohibited." },
      { title: "7. Limitation of Liability", content: "Cloud Mature strives to ensure the availability and reliability of its services. However, we do not guarantee uninterrupted access. Our liability is limited to the amount of services actually invoiced in the 12 months preceding the event giving rise to the claim." },
      { title: "8. Confidentiality", content: "Information exchanged in the course of our services is strictly confidential. Each party undertakes not to disclose the other party's confidential information without prior written authorization." },
      { title: "9. Termination", content: "You may delete your account at any time from your profile. Cloud Mature reserves the right to suspend or terminate an account in case of violation of these Terms, without notice." },
      { title: "10. Governing Law", content: "These Terms are governed by the applicable laws of the Republic of Guinea. Any dispute shall be submitted to the competent courts of Conakry." },
      { title: "11. Contact", content: "For any questions about these terms:\nCloud Mature - Conakry, Guinea\nEmail: info@cloudmature.com" },
    ],
  },
  auth: {
    portalTitle: "Client Portal",
    backToSite: "Back to site",
    continueGoogle: "Continue with Google",
    or: "or",
    fullName: "Full name",
    email: "Email",
    password: "Password",
    forgotPassword: "Forgot password?",
    noAccount: "Don't have an account?",
    hasAccount: "Already have an account?",
    signup: "Sign up",
    login: "Log in",
    sendLink: "Send link",
    loading: "Loading...",
    sendingLink: "Sending...",
    backToLogin: "Back to login",
    signupSuccess: "Registration successful!",
    signupSuccessDesc: "Check your email to confirm your account.",
    emailSent: "Email sent!",
    emailSentDesc: "Check your inbox to reset your password.",
    blocked: "Account blocked",
    blockedDesc: "Your account has been suspended. Please contact the administrator at info@cloudmature.com.",
    suspended: "Account suspended",
    suspendedDesc: "Your access has been restricted. Contact info@cloudmature.com for more information.",
    error: "Error",
    phoneTab: "Phone",
    emailTab: "Email",
    phone: "Phone number (E.164)",
    phonePlaceholder: "+1234567890",
    sendSmsCode: "Send code by SMS",
    sendingSmsCode: "Sending...",
    enterSmsCode: "Enter the 6-digit code received by SMS",
    verifySmsCode: "Verify code",
    verifyingSmsCode: "Verifying...",
    smsSent: "SMS sent!",
    smsSentDesc: "Check your phone for the verification code.",
    smsError: "SMS Error",
    smsVerified: "Verification successful!",
    smsVerifiedDesc: "You are now logged in.",
    smsInvalidCode: "Invalid or expired code",
    smsRateLimit: "Too many attempts. Please wait 10 minutes.",
    twilioTrial: "Note: Twilio trial - only verified numbers can receive SMS.",
  },
  mfa: {
    title: "MFA Verification",
    subtitle: "Two-factor authentication",
    backToLogin: "Back to login",
    initialSetup: "Initial setup",
    scanQr: "Scan this QR code with your authenticator app (Google Authenticator, Authy, etc.)",
    manualCode: "Or enter this code manually:",
    enterCode: "Enter the 6-digit code",
    activateMfa: "Activate MFA",
    verifying: "Verifying...",
    verificationRequired: "Verification required",
    verificationDesc: "Enter the code from your authenticator app to access the portal.",
    verify: "Verify",
    success: "Verification successful!",
    successDesc: "Portal access granted.",
    invalidCode: "Invalid code",
    smsOption: "SMS",
    totpOption: "Authenticator",
    emailOption: "Email",
    sendSmsCode: "Send SMS code",
    sendingSmsCode: "Sending...",
    smsSendDesc: "We will send a verification code to your phone",
    enterSmsCode: "Enter the code received by SMS",
    smsVerify: "Verify SMS code",
    smsSent: "Code sent!",
    smsSentDesc: "Check your phone for the verification code.",
    noPhone: "No phone number",
    noPhoneDesc: "Add a phone number to your profile to use SMS verification.",
    sendEmailCode: "Send email code",
    sendingEmailCode: "Sending...",
    emailSendDesc: "We will send a verification code to your email",
    enterEmailCode: "Enter the code received by email",
    emailVerify: "Verify email code",
    emailSent: "Code sent!",
    emailSentDesc: "Check your inbox for the verification code.",
  },
  resetPassword: {
    title: "New password",
    subtitle: "Choose a new password",
    newPassword: "New password",
    confirmPassword: "Confirm password",
    update: "Update",
    updating: "Updating...",
    success: "Password updated!",
    successDesc: "You can now log in.",
    invalidLink: "Invalid link",
    invalidLinkDesc: "This reset link is invalid or has expired.",
    mismatch: "Passwords do not match.",
    tooShort: "Password must be at least 6 characters.",
    backToLogin: "Back to login",
  },
  portal: {
    loading: "Loading...",
    dashboard: "Dashboard",
    projects: "My Portfolio",
    support: "Support",
    profile: "Profile",
    admin: "Administration",
    agentSpace: "Agent Space",
    logout: "Log out",
    welcome: "Welcome,",
    overview: "Here's an overview of your client space.",
    refresh: "Refresh",
    activeProjects: "Active Portfolio",
    openTickets: "Open Tickets",
    completed: "Completed",
    avgProgress: "Avg. Progress",
    myActivity: "My Activity",
    projectsByStatus: "Portfolio by Status",
    recentProjects: "Recent Portfolio",
    latestTickets: "Latest Tickets",
    noProjects: "No portfolio yet",
    noTickets: "No tickets yet",
    noData: "No data",
    noProjectsOrTickets: "No portfolio or tickets yet.",
    teamWillAdd: "Your CloudMature team will add your portfolio here.",
    total: "total",
    inProgress: "In Progress",
    done: "Completed",
    pending: "Pending",
    open: "Open",
    resolved: "Resolved",
    closed: "Closed",
    average: "on average",
    deadline: "Deadline",
    urgent: "Urgent",
    high: "High",
    normal: "Normal",
    myProjects: "My Portfolio",
    submitProject: "Submit a portfolio",
    cancel: "Cancel",
    search: "Search a portfolio...",
    statusFilter: "Status:",
    all: "All",
    newProject: "New portfolio",
    editProject: "Edit portfolio",
    projectName: "Portfolio name *",
    projectNamePlaceholder: "E.g.: Website redesign",
    description: "Description",
    descriptionPlaceholder: "Describe your portfolio, needs and goals...",
    estimatedBudget: "Estimated budget",
    budgetPlaceholder: "E.g.: $5,000 - $10,000",
    desiredDeadline: "Desired deadline",
    selectDate: "Select a date",
    desiredServices: "Desired services",
    priority: "Priority",
    attachments: "Attachments",
    addFiles: "Add files",
    submit: "Submit",
    save: "Save",
    submitting: "Submitting...",
    projectSubmitted: "Portfolio submitted!",
    projectSubmittedDesc: "Your portfolio has been sent successfully.",
    projectEdited: "Portfolio edited!",
    projectEditedDesc: "Changes have been saved.",
    noProjectsYet: "No portfolio",
    noProjectsYetDesc: "Submit your first portfolio to get started.",
    progress: "Progress",
    budget: "Budget",
    technologies: "Services",
    created: "Created on",
    modify: "Edit",
    attachedFiles: "Attached files",
    supportTickets: "Support",
    openTicketCount: "open",
    inProgressCount: "in progress",
    resolvedCount: "resolved",
    newTicket: "New ticket",
    subject: "Subject *",
    subjectPlaceholder: "Summarize your request",
    message: "Message *",
    messagePlaceholder: "Describe your issue or request in detail...",
    sendTicket: "Send ticket",
    ticketSent: "Ticket sent!",
    ticketSentDesc: "Our team will respond shortly.",
    filterAll: "All",
    noTicketsYet: "No tickets",
    noTicketsYetDesc: "Create a ticket to contact support.",
    conversation: "Conversation",
    noReplies: "No replies yet.",
    you: "You",
    team: "Team",
    replyPlaceholder: "Your reply...",
    send: "Send",
    myProfile: "My Profile",
    fullName: "Full name",
    company: "Company",
    phone: "Phone",
    saveProfile: "Save",
    saving: "Saving...",
    profileSaved: "Profile updated!",
    profileSavedDesc: "Your information has been saved.",
    deleteAccount: "Delete my account",
    deleteAccountConfirm: "Are you sure you want to delete your account? This action is irreversible.",
    accountDeleted: "Account deleted",
    accountDeletedDesc: "Your account has been marked for deletion.",
    profileIncomplete: "Please complete your profile (name, company, phone) within the remaining {days} day{s}.",
    profileOverdue: "The 30-day deadline to complete your profile has passed. Please fill it in immediately.",
    completeProfile: "Complete my profile",
    project: "portfolio",
    projects_count: "portfolio(s)",
    ticket: "ticket",
    tickets_count: "ticket(s)",
  },
  admin: {
    loading: "Loading...",
    overview: "Overview",
    projects: "Portfolio",
    tickets: "Tickets",
    contacts: "Contacts",
    users: "Users",
    portalClient: "Client portal",
    logout: "Log out",
    admin: "Admin",
    agent: "Agent",
    hello: "Hello,",
    agentDesc: "Here's your agent space - manage client tickets.",
    overviewTitle: "Overview",
    overviewDesc: "Track your platform activity in real time.",
    refresh: "Refresh",
    openTickets: "Open Tickets",
    inProgressTickets: "In Progress",
    resolvedTickets: "Resolved",
    myReplies: "My Replies",
    recentTickets: "Recent tickets to process",
    pending: "pending",
    noTicketsToProcess: "No tickets to process 🎉",
    registeredClients: "Registered Clients",
    totalProjects: "Total Portfolio",
    totalBudget: "Total Budget",
    active: "active",
    monthlyActivity: "Monthly Activity",
    projectsByStatus: "Portfolio by Status",
    ticketsByStatus: "Tickets by Status",
    latestSignups: "Latest Sign-ups",
    recentProjects: "Recent Portfolio",
    noData: "No data",
  },
  sharepoint: {
    title: "SharePoint",
    description: "Browse your SharePoint sites, files and lists.",
    filesTab: "Files",
    listsTab: "Lists",
    invoicesTab: "Invoices",
    selectSite: "Select a SharePoint site",
    searchSites: "Search sites...",
    noSites: "No SharePoint sites found.",
    selectDrive: "Select a document library",
    upload: "Upload",
    uploading: "Uploading...",
    uploadSuccess: "File uploaded successfully!",
    newFolder: "New folder",
    folderCreated: "Folder created successfully!",
    folderNamePlaceholder: "Folder name",
    cancel: "Cancel",
    create: "Create",
    emptyFolder: "This folder is empty.",
    emptyList: "This list is empty.",
    items: "items",
    error: "SharePoint Error",
    listsTitle: "SharePoint Lists",
    noLists: "No lists found.",
    searchFiles: "Search files...",
    noResults: "No matching files.",
  },
  install: {
    title: "Install CloudMature",
    subtitle: "Add the app to your home screen to access it like a native app.",
    ios1: "Tap the Share button at the bottom of Safari.",
    ios2: 'Select "Add to Home Screen".',
    ios3: 'Confirm by tapping "Add".',
    android1: "Tap the \u22EE menu at the top right of Chrome.",
    android2: 'Select "Install app" or "Add to Home Screen".',
    navButton: "Get the App",
  },
} as const;

export default en;
